'use strict'
import Vue from 'vue'
import { message } from 'ant-design-vue'

let show = (type, properties) => {
	return message[type](properties)
}

const messagge = {
	install: function(Vue, options) {
		Vue.$message = {
			success: ({ content, duration = 0, onClose, key }) =>
				show('success', { content, duration, onClose, key }),
			error: ({ content, duration = 0, onClose, key }) =>
				show('error', { content, duration, onClose, key }),
			info: ({ content, duration = 0, onClose, key }) =>
				show('info', { content, duration, onClose, key }),
			warning: ({ content, duration = 0, onClose, key }) =>
				show('warning', { content, duration, onClose, key }),
			warn: ({ content, duration = 0, onClose, key }) =>
				show('warn', { content, duration, onClose, key }),
			loading: ({ content, duration = 0, onClose, key }) =>
				show('loading', { content, duration, onClose, key }),
		}

		Vue.prototype.$message = {
			success: ({ content, duration = 0, onClose, key }) =>
				show('success', { content, duration, onClose, key }),
			error: ({ content, duration = 0, onClose, key }) =>
				show('error', { content, duration, onClose, key }),
			info: ({ content, duration = 0, onClose, key }) =>
				show('info', { content, duration, onClose, key }),
			warning: ({ content, duration = 0, onClose, key }) =>
				show('warning', { content, duration, onClose, key }),
			warn: ({ content, duration = 0, onClose, key }) =>
				show('warn', { content, duration, onClose, key }),
			loading: ({ content, duration = 0, onClose, key }) =>
				show('loading', { content, duration, onClose, key }),
		}
	},
}

Vue.use(messagge)

export default messagge
